export const useValidationEngine = (config, formData, otpState) => {
  const errors = {};

  config.forEach(section => {
    section.fields.forEach(field => {
      const value = formData[field.key];

      if (field.required && !value) {
        errors[field.key] = `${field.label} is required`;
      }

      if (
        field.type === "INPUT_OTP" &&
        field.required &&
        value &&
        !otpState[field.key]?.verified
      ) {
        errors[field.key] = `${field.label} not verified`;
      }
    });
  });

  return {
    errors,
    isValid: Object.keys(errors).length === 0
  };
};
